import React from 'react';
import { MutedBackground } from 'scy/Background';
import { SmallUppercase, AccentSmallUppercase } from 'scy/text';
import { StackedInput, Checkbox } from 'scy/Input';
import { allMedium, borderRadius } from 'scy/border.mod.scss';
import { clickable } from 'scy/utils.mod.scss';
import { flex, centerItems, flex1 } from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

class ProductEngraving extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      line_1: '',
      line_2: '',
      line_3: ''
    };
    this.setLine1 = this.setLine.bind(this, 1);
    this.setLine2 = this.setLine.bind(this, 2);
    this.setLine3 = this.setLine.bind(this, 3);
    this.updateEngraving = this.updateEngraving.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  setLine(n, event) {
    this.setState({ [`line_${n}`]: event.target.value });
  }

  updateEngraving() {
    this.props.setEngraving({
      line_1: this.state.line_1,
      line_2: this.state.line_2,
      line_3: this.state.line_3
    });
  }

  toggleSelected() {
    const selected = !this.state.selected;
    this.setState({ selected });
    if (selected) this.updateEngraving();
    else this.props.setEngraving(null);
  }

  render() {
    const price = this.props.product.engraving.price.toFixed(2);

    return (
      <MutedBackground
        className={`${allMedium} ${borderRadius} ${padding.sm} ${
          margin.bottom_sm
        }`}
      >
        <div className={`${flex} ${centerItems}`}>
          <SmallUppercase
            tag="label"
            htmlFor="hasEngraving"
            className={`${clickable} ${flex1}`}
          >
            <Checkbox
              id="hasEngraving"
              name="hasEngraving"
              className={margin.right_xs}
              checked={this.state.selected}
              onChange={this.toggleSelected}
            />
            Custom Engraving
          </SmallUppercase>
          <AccentSmallUppercase tag="span">+${price}</AccentSmallUppercase>
        </div>

        {this.state.selected && (
          <div className={margin.top_sm}>
            <StackedInput
              type="text"
              value={this.state.line_1}
              onChange={this.setLine1}
              onBlur={this.updateEngraving}
              placeholder="Enter text (20 character max per line)"
              maxLength={20}
            />
            <StackedInput
              type="text"
              value={this.state.line_2}
              onChange={this.setLine2}
              onBlur={this.updateEngraving}
              maxLength={20}
            />
            <StackedInput
              type="text"
              value={this.state.line_3}
              onChange={this.setLine3}
              onBlur={this.updateEngraving}
              maxLength={20}
            />
          </div>
        )}
      </MutedBackground>
    );
  }
}

export default ProductEngraving;
